/**
 * Stock-alert hand-off.
 */
import { emit } from '../events/emitter.js';

export function requestStockAlert(detail, triggerElement) {
	emit('bcQuickBuy:stockAlertRequested', {
		...detail,
		triggerElement,
	});
}
